
export {Base64UploadAdapter,
FileReader,
FileRepository,
SimpleUploadAdapter} from '../../../frontend-editor-ckeditor-web/__liferay__/exports/@ckeditor$ckeditor5-upload$dist$index.js.js';
